module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('br'), _c('div', {
    staticClass: "text-gray-color"
  }, [_vm._v("Deseja realmente excluir esta tarefa?")]), _c('br'), _c('div', {
    staticClass: "rosy-red-color"
  }, [_c('div', [_vm._v(_vm._s(_vm.task.summaryText()))]), _c('div', [_vm._v(_vm._s(_vm.task.dueOnText()))])]), _c('br')])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn btn-gray",
    on: {
      "click": function($event) {
        return _vm.$emit("cancel-removing")
      }
    }
  }, [_vm._v("Voltar")]), _c('div', {
    staticClass: "btn btn-danger no-margin",
    on: {
      "click": _vm.destroyTask
    }
  }, [_vm._v("Sim, excluir")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_vm._v("EXCLUIR TAREFA"), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1aa4d64d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/confirm_destroy.vue
// module id = 1033
// module chunks = 1